<template>
  <div :class="className">
    <label>
      {{ label }}
      <BaseIcon class="base-input__padlock" v-if="isLocked" :name="'locked-padlock'"/>
    </label>
    <textarea v-bind="$attrs" :value="value" v-on="listeners" v-validate="validate"
      :style="{ minHeight: `${minHeight}px` }" :disabled="isFieldDisabled"></textarea>
    <TypographyInputError v-if="hasErrors">{{ errors.first($attrs.name) }}</TypographyInputError>
    <TypographyInputHint v-if="hint">{{ hint }}</TypographyInputHint>
    <TypographyMeta v-if="meta" v-html="meta"></TypographyMeta>
  </div>
</template>

<script>
  import BaseInput from './BaseInput'

  export default {
    extends: BaseInput,
    props: {
      minHeight: { default: 150 }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/base/BaseTextarea.vue